var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({attrs:{"loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},'Button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }